module.exports = __webpack_public_path__ + "static/media/LeftCircle.301e7441.svg";